export default {
  namespaced: true,
  state: {
    languageList: localStorage.getItem("as-languageList")
      ? JSON.parse(localStorage.getItem("as-languageList")) ?? []
      : [],
    languageData: localStorage.getItem("as-languageData")
      ? JSON.parse(localStorage.getItem("as-languageData")) ?? []
      : [],
    // 数据变化标志
    dataUpdate: "",
    // 默认关闭，用户退出时设置为关闭
    hasServicePage: false,
    // 只要有as的权限，就可以进入 用户密码修改界面
    hasAsPermission: false,
    // 收件箱详情
    inboxDetailDialog: {
      show: false,
      id: "",
    },
    // license信息
    inboxStatus: "first",
    licenseUpdate: false,
    noShowTips: localStorage.getItem("noShowTips")
      ? JSON.parse(localStorage.getItem("noShowTips"))
      : false, // 默认显示license的提示信息
  },
  mutations: {
    initLanguageList(state, payload) {
      state.languageList = payload;
      localStorage.setItem("as-languageList", JSON.stringify(payload));
    },
    initLanguageData(state, payload) {
      state.languageData = payload;
      localStorage.setItem("as-languageData", JSON.stringify(payload));
    },
    updateLanguageList(state) {
      state.languageList =
        JSON.parse(localStorage.getItem("as-languageList")) ?? [];
    },
    updateLanguageData(state) {
      state.languageData =
        JSON.parse(localStorage.getItem("as-languageData")) ?? [];
    },
    dataUpdate(state, payload) {
      state.dataUpdate = payload;
    },
    hasServicePage(state, payload) {
      state.hasServicePage = payload;
    },
    hasAsPermission(state, payload) {
      state.hasAsPermission = payload;
    },
    changeInboxDetailDialog(state, payload) {
      state.inboxDetailDialog = payload;
    },
    changeInboxStatus(state, payload) {
      state.inboxStatus = payload;
    },
    licenseUpdate(state, payload) {
      state.licenseUpdate = payload;
    },
    changeTipsStatus(state, payload) {
      state.noShowTips = payload;
      localStorage.setItem("noShowTips", JSON.stringify(payload));
    },
  },
};
